export const GameSelectors = [
  // {
  //   gameID: "game_of_the_generals",
  //   name: "Game of the Generals",
  //   description:
  //     "A tactical fog of war game where players try to capture the enemy flag or move their flag to the enemy backrow.",
  //   playerMin: 2,
  //   playerMax: 2,
  // },
  // {
  //   gameID: "golf_gulf",
  //   name: "Golf Gulf",
  //   description:
  //     "Take aim and swing in this profile-view golf game and beat your friends to the hole.",
  //   playerMin: 1,
  //   playerMax: 16,
  // },
  {
    gameID: "letris",
    name: "Letris",
    description:
      "Use the falling letter blocks to create words horizontally and vertically to prevent your stack from reaching the top.",
    playerMin: 1,
    playerMax: 8,
  },
  // {
  //   gameID: "hackjack",
  //   name: "HackJack",
  //   description:
  //     "A PvP twist on the classic blackjack game where the goal is to steal as much data as you can without going over your storage. Use programs to give yourself the upper hand over your opponent and hack into their system before they can hack yours.",
  //   playerMin: 2,
  //   playerMax: 2,
  // },
  {
    gameID: "sushi_goat",
    name: "Sushi Goat",
    description:
      "Create high-scoring words to fill your sushi boat and have the better boat at the end to become the sushi goat!",
    playerMin: 2,
    playerMax: 2,
  },
];
